import React from 'react'
import styled from 'styled-components'

import { TitleRow } from './title-row'
import { InputRow } from './input-row'

export const TabPaneChangeRequest = props => {
  const { changeRequests, crType, handleInput } = props

  return (
    <Root>
      <TitleRow />
      <RowWrapper>
        {changeRequests.map((changeRequest, key) => (
          <InputRow
            idx={ key.toString() }
            key={ key }
            crType={ crType }
            changeRequest={ changeRequest }
            handleInput={ handleInput }
          />
        ))}
      </RowWrapper>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const RowWrapper = styled.div`
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-change-request/index.js